// extracted by mini-css-extract-plugin
module.exports = {"colorSurrogate":"MagazineLogoMobile-module-color-surrogate","colorWhite":"MagazineLogoMobile-module-color-white"};